var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33.084,
    viewBox: "0 0 34 33.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58468",
    "data-name": "Group 58468",
    transform: "translate(-454 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Image",
    "data-name": "Iconly/Light-Outline/Image",
    transform: "translate(454 188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M18.088,0c4.282,0,7.159,3,7.159,7.462V17.773c0,4.463-2.878,7.462-7.159,7.462H7.147c-4.275,0-7.147-3-7.147-7.462V7.462C0,3,2.872,0,7.147,0Zm0,1.9H7.147C3.958,1.9,1.9,4.082,1.9,7.462V17.773c0,3.381,2.061,5.564,5.249,5.564H18.088c3.2,0,5.262-2.183,5.262-5.564V7.462C23.35,4.082,21.285,1.9,18.088,1.9Z",
    transform: "translate(0 0)",
    fill: "#1b2737",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58456",
    "data-name": "Group 58456",
    transform: "translate(470.444 202.759)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_531",
    "data-name": "Ellipse 531",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-2.444 -1.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_531_-_Outline",
    "data-name": "Ellipse 531 - Outline",
    d: "M7.589,1.265a6.324,6.324,0,1,0,6.324,6.324A6.332,6.332,0,0,0,7.589,1.265M7.589,0A7.589,7.589,0,1,1,0,7.589,7.589,7.589,0,0,1,7.589,0Z",
    transform: "translate(0 0.42)",
    fill: "#1b2737",
    stroke: "#1b2737",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M5.227-11.426a.5.5,0,0,0,.5-.5v-4.277l1.66,1.667a.5.5,0,0,0,.713,0,.5.5,0,0,0,0-.714L5.585-17.786a.552.552,0,0,0-.052-.045l.052.045a.5.5,0,0,0-.087-.07l-.023-.013a.369.369,0,0,0-.045-.023l-.012,0a.377.377,0,0,0-.049-.017l-.031-.007L5.3-17.93l-.032,0-.04,0-.04,0-.029,0h0l.073-.006a.505.505,0,0,0-.11.012l-.031.008a.38.38,0,0,0-.049.016l-.012.006a.375.375,0,0,0-.046.022l-.022.014a.34.34,0,0,0-.036.025.592.592,0,0,0-.056.05L2.348-15.253a.5.5,0,0,0,0,.714.5.5,0,0,0,.713,0l1.66-1.667v4.277A.5.5,0,0,0,5.227-11.426Z",
    transform: "translate(2.362 22.69)",
    fill: "#1b2737",
    stroke: "#1b2737",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Play",
    "data-name": "Iconly/Bold/Play",
    transform: "translate(463.659 197.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42434",
    "data-name": "Path 42434",
    d: "M5.324,3.253a1.216,1.216,0,0,0-.551.131,1.133,1.133,0,0,0-.489.542,5.841,5.841,0,0,0-.157.638,13.964,13.964,0,0,0-.149,2.28,16.159,16.159,0,0,0,.131,2.21,4.949,4.949,0,0,0,.21.795,1.1,1.1,0,0,0,.97.594h.035a3.038,3.038,0,0,0,.813-.245A13.343,13.343,0,0,0,9.624,7.822h0l.052-.052a3.6,3.6,0,0,0,.245-.28,1.052,1.052,0,0,0,.21-.637A1.1,1.1,0,0,0,9.9,6.171c-.035-.035-.166-.183-.288-.306A13.361,13.361,0,0,0,6.05,3.454,2.974,2.974,0,0,0,5.324,3.253Z",
    transform: "translate(-3.979 -3.253)",
    fill: "#1a2737"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/uploadVideo.210fc104c469ad6bf868f1810590db90.svg";
export { ForwardRef as ReactComponent };